module.exports = __webpack_public_path__ + "static/herbical-95a1a32b5b56e7f0949c4658cf8c15c0.png";